import {connect} from 'react-redux';
import {RecordAbsorbance as Component} from './RecordAbsorbance';
import {
  showModal,
  absorbanceTableCellUpdate,
  questionTableCellUpdateResults
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    absorbanceTable: state.notebook.protocolSection.scene.absorbanceTable
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    absorbanceTableCellUpdate: (data) => {
      dispatch(absorbanceTableCellUpdate(data))
    },
    questionTableCellUpdateResults: (data) => {
      dispatch(questionTableCellUpdateResults(data))
    },
  };
}

export const RecordAbsorbance = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
